var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFeedback = function SvgFeedback(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#194A74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.992,1.6 C15.992,0.72 15.28,0 14.4,0 L1.6,0 C0.72,0 0,0.72 0,1.6 L0,11.2 C0,12.08 0.72,12.8 1.6,12.8 L12.8,12.8 L16,15 L15.992,1.6 Z",
    id: "Path",
    strokeWidth: 1.3,
    fillRule: "nonzero",
    transform: "translate(8.000000, 7.500000) scale(-1, 1) translate(-8.000000, -7.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84,3.6 L12.24,3.6",
    id: "Line-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84,6.4 L12.24,6.4",
    id: "Line-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84,9.2 L12.24,9.2",
    id: "Line-2",
    strokeLinecap: "square"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Feedback.ccb0bfb1.svg";
export { ForwardRef as ReactComponent };